import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Notifications.css";

const NotificationContext = createContext({
  showNotification: () => {},
});

export const useNotifications = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const navigate = useNavigate();
  const [notifications, setNotifications] = useState([]);
  const sessionHandledRef = useRef(false);

  const showNotification = useCallback((type, text) => {
    if (!text) return;

    const id = `${Date.now()}-${Math.random()}`;
    setNotifications(prev => [...prev, { id, type, text }]);
    window.setTimeout(() => {
      setNotifications(prev => prev.filter(item => item.id !== id));
    }, 5000);
  }, []);

  useEffect(() => {
    const handleNotify = (event) => {
      const { type = "success", text } = event.detail || {};
      showNotification(type, text);
    };

    const handleSessionExpired = (event) => {
      if (sessionHandledRef.current) return;
      sessionHandledRef.current = true;

      localStorage.removeItem("token");
      localStorage.removeItem("accountType");
      showNotification(
        "warning",
        event.detail?.text || "Ihre Session ist abgelaufen. Bitte melden Sie sich erneut an."
      );
      navigate("/", { replace: true });

      window.setTimeout(() => {
        sessionHandledRef.current = false;
      }, 5000);
    };

    window.addEventListener("app:notify", handleNotify);
    window.addEventListener("app:session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("app:notify", handleNotify);
      window.removeEventListener("app:session-expired", handleSessionExpired);
    };
  }, [navigate, showNotification]);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <div className="notification-stack" aria-live="polite" aria-atomic="true">
        {notifications.map(notification => (
          <div
            key={notification.id}
            className={`notification-toast ${notification.type}`}
            role="status"
          >
            {notification.text}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;
